export const AriaHasPopup = {
  Dialog: 'dialog',
  Grid: 'grid',
  ListBox: 'listbox',
  Menu: 'menu',
  Tree: 'tree',
};
